// extracted by mini-css-extract-plugin
module.exports = {"root":"ParticipantsPage_root__YDcv0","submitButton":"ParticipantsPage_submitButton__1gxX9","titleRow":"ParticipantsPage_titleRow__rtuVe"};